import { Model, store } from "hybrids";
import { get } from "~/utils/api";
import User from "./User";

interface UserDetails {
  id: string;
  fullDescription: string;
  follows: User[];
  type: string;
}

const UserDetails: Model<UserDetails> = {
  id: true,
  fullDescription: "",
  follows: [User],
  [store.connect]: (id) => get("/users/:id/details", id),
  type: "",
};

export default UserDetails;
